import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Code2, Briefcase, Megaphone, Stethoscope } from 'lucide-react';
interface InvestorSlide13Props {
  isDark?: boolean;
}
export function InvestorSlide13({
  isDark = false
}: InvestorSlide13Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const allocations = [{
    label: 'Product',
    pct: '40%',
    desc: 'Platform dev, Teams expansion',
    icon: Code2,
    color: 'mint'
  }, {
    label: 'Sales',
    pct: '30%',
    desc: 'Enterprise team, Customer Success',
    icon: Briefcase,
    color: 'navy'
  }, {
    label: 'Marketing',
    pct: '20%',
    desc: 'Brand, Content, Demand Gen',
    icon: Megaphone,
    color: 'orange'
  }, {
    label: 'Clinical',
    pct: '10%',
    desc: 'Provider network expansion',
    icon: Stethoscope,
    color: 'slate'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-213">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-214">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-215">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-216">
            Use of Funds
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-217">
            Accelerating product development and enterprise go-to-market.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-218">
          {allocations.map((item, idx) => {
          const Icon = item.icon;
          return <motion.div key={idx} variants={itemVariants} className={`rounded-3xl p-6 sm:p-8 flex flex-col items-center text-center relative overflow-hidden ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige shadow-sm'}`} data-id="element-219">
                <div className={`absolute top-0 left-0 w-full h-2 ${isDark ? `bg-heliona-${item.color}` : `bg-heliona-${item.color === 'mint' ? 'mint-dark' : item.color}`}`} data-id="element-220" />

                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-6 ${isDark ? 'bg-white/5' : `bg-heliona-${item.color}/10`}`} data-id="element-221">
                  <Icon className={`w-7 h-7 ${isDark ? 'text-white' : `text-heliona-${item.color === 'mint' ? 'mint-dark' : item.color}`}`} data-id="element-222" />
                </div>

                <div className={`text-4xl font-bold mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-223">
                  {item.pct}
                </div>

                <h3 className={`text-lg font-bold mb-2 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-224">
                  {item.label}
                </h3>

                <p className={`text-sm ${isDark ? 'text-white/60' : 'text-heliona-text-gray'}`} data-id="element-225">
                  {item.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </motion.div>;
}